import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import InvitationAnalyticsPage from "@/pages/admin/InvitationAnalyticsPage";

export const Route = createFileRoute("/_admin/admin/invitation-analytics")({
  head: () => pageHead("Admin · Invitation Analytics", "AKIVA admin · invitation analytics portal.", "/admin/invitation-analytics", true),
  component: InvitationAnalyticsPage,
});
